/**
 * Codira brand assets, served from /public.
 *  - Logo: the [ C ODIR A ] mark + small ™ stack (compact)
 *  - Brand: full horizontal lockup
 */
export function CodiraLogo({ className = "h-8" }) {
  return <img src="/codira-logo.svg" alt="Codira" className={className} />;
}

export function CodiraBrand({ className = "h-7" }) {
  return <img src="/codira-brand.svg" alt="Codira Ad Studio" className={className} />;
}
